<template>
    <div>
        <transition name="custom-classes-transition" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div v-if="moodviewOpen" class="moodview-bg"></div>
        </transition>
        <transition name="custom-classes-transition" enter-active-class="animated slow slideIn" leave-active-class="animated slideOut">
            <div v-if="moodviewOpen" class="card moodview-wrapper post-wrapper background-grayblue" v-click-outside="closeMoodview">
                <feed is-dynamic="false" :topic-data="moodboardTopic" view-type="moodview"></feed>
            </div>
        </transition>
    </div>
</template>

<script>
    import Global from '../mixins/Global.js'
    import PreventFromClosing from '../mixins/PreventFromClosing.js'
    import {mapState, mapMutations} from 'vuex';
    import axios from 'axios'
    import vClickOutside from 'v-click-outside'

    export default {
        mixins: [Global, PreventFromClosing],
        name: 'MoodView',

        computed: {
            ...mapState([
                'moodviewOpen',
                'moodboardTopic',
                'modalVisible',
            ]),

          ...mapState('modal',
              ['popup_open']),
        },

        methods: {
            closeMoodview() {
                let self = this;

                if(!self.modalVisible && !this.prevent_from_closing && !this.popup_open) {
                    self.$store.commit('setMoodview', false);
                }
            },
        },

        directives: {
            clickOutside: vClickOutside.directive,
        }
    }
</script>

<style lang="scss">
    .animated {
        animation-duration: 0.3s;
        animation-fill-mode: both;
        transition-timing-function: ease-in-out;

        &.slow {
            animation-duration: 0.6s;
        }
    }

    .fadeIn {
        animation-name: fadeIn;

        @keyframes fadeIn {
            from {
                opacity: 0;
            }

            to {
                opacity: 0.75;
            }
        }
    }

    .fadeOut {
        animation-name: fadeOut;

        @keyframes fadeOut {
            from {
                opacity: 0.75;
            }

            to {
                opacity: 0;
            }
        }
    }

    .slideIn {
        animation-name: slideIn;

        @keyframes slideIn {
            from {
                opacity: 0;
                transform: translateY(640px);
            }

            to {
                opacity:1;
                transform: translateY(0);
            }
        }
    }

    .slideOut {
        animation-name: slideOut;

        @keyframes slideOut {
            from {
                opacity:1;
                transform: translateY(0px);
            }

            to {
                opacity: 0;
                transform: translateY(640px);
            }
        }
    }
</style>